import { render, staticRenderFns } from "./randomMerklisten.vue?vue&type=template&id=6de08331&"
import script from "./randomMerklisten.vue?vue&type=script&lang=js&"
export * from "./randomMerklisten.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports